export const TOOL_PART_PREFIX = "tool-";

/** Every live clock stays hidden until the work has run this long. */
export const SHOW_TIME_AFTER_SECONDS = 20;
